import { digestSchema } from './digestSchema' // TODO: get rid of schema digestion and work with their original json structures ?
import { addReferencedFieldsToSchema } from './addReferencedFieldsToSchema'
import { addNestedFieldsToSchema } from './addNestedFieldsToSchema'
import type { CollectionsApi } from '@wix/wix-code-collections-api'
import type { DigestedSchema } from '@wix/wix-data-client-common-standalone'

const fetchAllSchemas = (
  collectionsApi: CollectionsApi,
  { includeReferenceData = false, includeHiddenAppCollections = false } = {},
): Promise<DigestedSchema[]> =>
  collectionsApi
    .getAll({ includeHiddenAppCollections })
    .then(rawSchemas =>
      rawSchemas.map(schema => digestSchema({ rawSchema: schema })),
    )
    .then(digestedSchemas =>
      includeReferenceData
        ? digestedSchemas.map(schema =>
            addReferencedFieldsToSchema(schema, digestedSchemas),
          )
        : digestedSchemas,
    )
    .then(digestedSchemas => digestedSchemas.map(addNestedFieldsToSchema))

const fetchMultipleSchemas = async (
  collectionsApi: CollectionsApi,
  collectionIds: string[],
  { includeReferenceData = false } = {},
): Promise<DigestedSchema[]> => {
  const allDigestedSchemas = await fetchAllSchemas(collectionsApi, {
    includeReferenceData: false,
  })
  return allDigestedSchemas
    .filter(schema => collectionIds.includes(schema.id))
    .map(digestedSchema =>
      includeReferenceData
        ? addReferencedFieldsToSchema(digestedSchema, allDigestedSchemas)
        : digestedSchema,
    )
}

const fetchSchema = async (
  collectionsApi: CollectionsApi,
  collectionId: string,
  { includeReferenceData = false } = {},
): Promise<DigestedSchema> =>
  fetchMultipleSchemas(collectionsApi, [collectionId], {
    includeReferenceData,
  }).then(digestedSchemaInArray => digestedSchemaInArray[0])

export const fetch = fetchSchema
export const fetchAll = fetchAllSchemas
export const fetchMultiple = fetchMultipleSchemas
